import { IAvatarAssetImage } from './IAvatarAssetImage';

export interface IAvatarAssetLayer {
    id: string;
    positionId: string; // IAssetLayerPosition->id
    image: IAvatarAssetImage;
    isFace?: boolean;
}
